<template>
  <Modal :value="value" v-on="$listeners">
    <p class="pb-2 text-xl font-bold leading-tight">
      {{ $t('popups.removeVoucher.title', { code: voucher.code }) }}
    </p>

    <div
      v-for="(error, index) in errors"
      :key="index"
      class="w-full p-4 mt-2 mb-4 bg-sw_red_error-background"
    >
      <p class="pb-2 text-sm font-bold leading-none xl:text-lg">
        {{ $t(`errors.type.${error}.title`, brandInfo) }}
      </p>
      <p class="text-xs xl:text-sm" v-html="$t(`errors.type.${error}.description`, brandInfo)" />
    </div>

    <div class="flex flex-col-reverse justify-end pt-5 xl:flex-row xl:pt-8">
      <div class="mt-4 xl:mt-0 xl:mr-4">
        <Button
          :loading="loading"
          variant="secondary"
          type="button"
          @click="deleteVoucher"
        >
          {{ $t('popups.removeVoucher.button.submit') }}
        </Button>
      </div>
      <div>
        <Button
          :disabled="loading"
          type="button"
          @click.prevent="$emit('input', false)"
        >
          {{ $t('popups.removeVoucher.button.close') }}
        </Button>
      </div>
    </div>
  </Modal>
</template>

<script lang="ts">
import Modal from '~brand-components/swiss/modal/modal.vue'
import Button from '~brand-components/swiss/button/button.vue'
import RemoveVoucherPopup from '~app/psp/base/remove-voucher-popup.ts'

export default RemoveVoucherPopup.extend({
  components: {
    Modal,
    Button,
  },
})
</script>
